class FatalError extends Error {
  constructor(message, statusCode = null, headers = null,model = null) {
    super(message);
    this.message = message;
    this.statusCode = statusCode;
    this.headers = headers;
    this.model = model;
    Error.captureStackTrace(this, this.constructor);
  }
}

export default FatalError;
